import { fetchGenericScreenInfo } from "../../webservices/generic/screenWs";
import { FETCHING_SCREEN, FETCHING_SCREEN_SUCCESS, FETCHING_SCREEN_ERROR, FETCHING_DATA_IN_PROGRESS, FETCHING_DATA_DONE } from "./types";

export const fetchScreenInfo = (screenId) => {
    //console.log('fetch screen info action: ' + screenId);
    return (dispatch) => {
        // dispatch({ type: FETCHING_SCREEN });
        dispatch({ type: FETCHING_DATA_IN_PROGRESS });
        fetchGenericScreenInfo(screenId)
        .then(function (response) {
            if (response.data.success === true){
                let screenInfo = response.data.result;
                dispatch({ type: FETCHING_SCREEN_SUCCESS, payload: screenInfo });
                dispatch({ type: FETCHING_DATA_DONE });
            }
            else {
                dispatch({ type: FETCHING_SCREEN_ERROR, payload: {error: 'Fetching Screen Error'} });
                dispatch({ type: FETCHING_DATA_DONE });
            }
        })
        .catch(function (error) {
            dispatch({ type: FETCHING_SCREEN_ERROR, payload: {error: 'Fetching Screen Error'} });
            dispatch({ type: FETCHING_DATA_DONE });
        })
    }
}